import { render, staticRenderFns } from "./FormKeyword.vue?vue&type=template&id=88e9fef2&"
import script from "./FormKeyword.vue?vue&type=script&lang=js&"
export * from "./FormKeyword.vue?vue&type=script&lang=js&"
import style0 from "./FormKeyword.vue?vue&type=style&index=0&id=88e9fef2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e9fef2')) {
      api.createRecord('88e9fef2', component.options)
    } else {
      api.reload('88e9fef2', component.options)
    }
    module.hot.accept("./FormKeyword.vue?vue&type=template&id=88e9fef2&", function () {
      api.rerender('88e9fef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Translation/FormKeyword.vue"
export default component.exports